import { z } from "zod";

import { TEXT_MEDIUM_LENGTH } from "~/common/constants";
import { pharmacySchema } from "./pharmacySchema";

const baseSchema = z.object({
  medication: z.string(),
  comment: z.string().optional(),
  pharmacy: z.string({ error: "Please select a pharmacy" }),
});

const existingPharmacySchema = baseSchema.extend({
  isNewPharmacy: z.literal(false),
});

export const newPharmacySchema = baseSchema.extend({
  isNewPharmacy: z.literal(true),
  newPharmacy: pharmacySchema,
});

export const requestScriptSchema = z.discriminatedUnion("isNewPharmacy", [
  existingPharmacySchema,
  newPharmacySchema,
]);

export const baseResolveIssueSchema = z.object({
  medication: z.string(),
  reason: z
    .string({ error: "Please select a pharmacy" })
    .min(1, "Please provide a reason.")
    .max(
      TEXT_MEDIUM_LENGTH,
      `Please provide a reason less than ${TEXT_MEDIUM_LENGTH} characters`,
    ),
  pharmacy: z.string({ error: "Please select a pharmacy" }),
  pre_authorization_request: z.boolean(),
});

const resolveIssueExistingPharmacySchema = baseResolveIssueSchema.extend({
  isNewPharmacy: z.literal(false),
});

export const resolveIssueNewPharmacySchema = baseResolveIssueSchema.extend({
  isNewPharmacy: z.literal(true),
  newPharmacy: pharmacySchema,
});

export const resolveIssueSchema = z.discriminatedUnion("isNewPharmacy", [
  resolveIssueExistingPharmacySchema,
  resolveIssueNewPharmacySchema,
]);
